<template>
  <div class="home">
    <div class="container">
      <div class="main">
        <div class="logo">
          <img src="@/assets/img/chiilih.svg" alt="">
        </div>
        <div class="swiperbox">
          <swiper :options="swiperOption">
            <swiper-slide><img src="@/assets/img/jsmagic1pict1.jpg" class="swiper swiper-lazy"></swiper-slide>
            <swiper-slide><img src="@/assets/img/jsmagic1pict2.jpg" class="swiper swiper-lazy"></swiper-slide>
            <swiper-slide><img src="@/assets/img/jsmagic1pict3.jpg" class="swiper swiper-lazy"></swiper-slide>
            <swiper-slide><img src="@/assets/img/jsmagic1pict4.jpg" class="swiper swiper-lazy"></swiper-slide>
            <swiper-slide><img src="@/assets/img/jsmagic1pict5.jpg" class="swiper swiper-lazy"></swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev icon-circle-left2" slot="button-prev"></div>
            <div class="swiper-button-next icon-circle-right2" slot="button-next"></div>
          </swiper>
        </div>
        <router-link class="tob" to="/brand">语音导览馆
          <i class="icon-s5-612 animated fadeInDown infinite bounce"></i>
        </router-link>
      </div>
    </div>
    <div class="navsBlk"></div>
  </div>
</template>

<script>
import navs from '@/components/nav'
export default {
  name: 'HOME',
  components: {
    navs
  },
  data() {
    return {
      msg: 'HOME',
      swiperOption: {
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created() {
    // this.$store.state.player.playerDisplay = false
    $(window).scrollTop(0)
    this.$store.state.player.ize = false
  },
  // swiper() {
  //   return this.$refs.mySwiper.swiper
  // },
  methods: {},
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }
}
</script>

<style lang="scss" scoped>
$red: rgb(219, 4, 15);
$gol: rgb(143, 116, 53);
$gol-lig: rgb(187, 162, 103);

html,

.home {
  .main {
    a.tob {
      color: rgba($gol, 0.5);
      width: 100%;
      font-weight: 300;
      font-size: 1.6rem;
      margin: 60px auto;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      i {
        width: 100%;
        margin: 16px;
        font-size: .8rem;
        color: $red;
      }
    }
  }
}
.logo {
  padding: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    max-width: 580px;
  }
}
.swiperbox {
  width: 90%;
  // padding: 0;
  display: block;
  height: auto;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 3px 12px 1px rgba(152, 100, 133, 0.8);
  .icon-circle-left2,
  .icon-circle-right2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }
}
.swiper-container.swiper-container-horizontal.swiper-container-ios {
  border-radius: 12px;
  overflow: hidden;
}
.swiper-container.swiper-container-horizontal.swiper-container-android {
  border-radius: 12px;
  overflow: hidden;
}
img.swiper {
  width: 100%;
  display: inline-block;
  float: left;
}
section {
  width: 90%;
  display: block;
  margin: 20px auto;
  padding: 20px;
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue